import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import * as React from 'react';

const Separator = (props: {}) => {
  return <ArrowRightIcon className='separator' />;
};

export { Separator };
